import { Component, ViewChild, OnInit ,ElementRef,OnChanges, SimpleChanges,Input} from '@angular/core';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { MatMenuTrigger } from '@angular/material/menu';
import { PlanogramStateService } from 'src/services/planogram-state.service';
import { Papa } from 'ngx-papaparse';
import { Observable, SubscriptionLike } from 'rxjs';
import { AdminBaseData, adminCooler } from 'src/modals/planogram';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import {
  FormGroup,
  FormControl,
  Validators,
  FormBuilder,
  AbstractControl,
} from '@angular/forms';


@Component({
  selector: 'app-admin-guidelines-panel',
  templateUrl: './admin-guidelines-panel.component.html',
  styleUrl: './admin-guidelines-panel.component.css',
})
export class AdminGuidelinesPanelComponent implements OnInit {
  dataSource = new MatTableDataSource();
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort, { static: false }) set sort(value: MatSort) {
    this.dataSource.sort = value;
  }
  @ViewChild(MatMenuTrigger) uploadTriggerBtn: MatMenuTrigger;
  @ViewChild(MatMenuTrigger) downloadTriggerBtn: MatMenuTrigger;
  @ViewChild('fileInput') fileInputRef!: ElementRef;
  selectedUploadFile: string = '';
  selectedDownloadFile: string = '';
  columns = ['channel', 'caser', 'group', 'sku_name', "min_facings","max_facings"];
  adminBaseDataSubscription: SubscriptionLike;
  adminBaseDataObservable: Observable<AdminBaseData[]> =
    this.planogramState.admin_base_data;
  adminBaseDataBasedOnTypeOfFileSubscription: SubscriptionLike;
  adminBaseDataBasedOnTypeOfFileObservable: Observable<any> =
    this.planogramState.admin_base_data_based_on_type_of_file;
  adminBaseData: AdminBaseData[];
  adminBaseDataBasedOnTypeOfFile:any;
  files = [
    'Nielsen Data',
    'Plano Guideline',
    'Bottler X Unit',
    'UF List',
    'Channel Mapping',
    'Placement Matrix'
  ];
  files_payload:any = {
    'Nielsen Data': 'nielsen_data',
    'Plano Guideline': 'guidelines',
    'Bottler X Unit': 'bottler_x_unit',
    'UF List': 'uf_list',
    'Channel Mapping': 'channel_map',
    'Placement Matrix':'placement_matrix'
  };
  selectionSequence=["channel","caser","group"]
  pageSize = 6;
  start=0;
  end=this.pageSize;
  pageIndex = 0;
  filtered_admin_base_data:AdminBaseData[];
  channels:string[]=[];
  casers:string[]=[];
  orders:number[]=[];
  groups:string[]=[];
  loader: Observable<boolean> = this.planogramState.loader;
  is_show_loader = false;
  base_data_dropdown_form_group: FormGroup;
  constructor(
    private _formBuilder: FormBuilder,
    private planogramState: PlanogramStateService,
    private papa: Papa
  ) {
    this.base_data_dropdown_form_group = this._formBuilder.group({
      channel: new FormControl({ value: [], disabled: false }),
      caser: new FormControl({ value: [], disabled: false }),
      group: new FormControl({ value: [], disabled: false }),
    });
    this.planogramState.getAdminBaseData({ type: 'guidelines' });
  }
  ngOnInit(): void {
    this.adminBaseDataSubscription = this.adminBaseDataObservable.subscribe(
      (data) => {
        this.filtered_admin_base_data=data
        this.adminBaseData = data;
        this.dataSource.data = data.slice(0,this.pageSize);
        this.getUniqueColumnValues(data,0)
      }
    );
  }

  ngOnDestroy(): void {
    if(this.adminBaseDataBasedOnTypeOfFileSubscription){
      this.adminBaseDataBasedOnTypeOfFileSubscription.unsubscribe();
    }
  }

 

  openInputForUpload(fileName:string): void {
    this.fileInputRef.nativeElement.click();
    this.selectedUploadFile=fileName
  }

  uploadFile(event:any) {
    const file: File = event.target.files[0];
    const formData = new FormData();
    formData.append('file', file);
    formData.append('type',this.files_payload[this.selectedUploadFile])
    this.planogramState.uploadAdminBaseData(formData)
  }

  downloadFile(file: string) {
    if (this.adminBaseDataBasedOnTypeOfFileSubscription) {
      this.adminBaseDataBasedOnTypeOfFileSubscription.unsubscribe();
    }
    this.selectedDownloadFile = file;
    this.planogramState.getAdminBaseDataBasedOnTypeOfFile({type:this.files_payload[file]})
      this.adminPanelBaseDataBasedOnTypeOfFileSubscription();
  }

  downloadBaseData(filename:string,baseData:any) {
    let headers:string[] = Object.keys(baseData[0]);
    headers=headers.filter(v=>v!="id")
    let data: any = baseData;
    let config={columns:headers}
    let result = this.papa.unparse(data,config);
    let blob = new Blob(['\ufeff' + result], {
      type: 'text/csv;charset=utf-8;',
    });
    let dwldLink = document.createElement('a');
    let url = URL.createObjectURL(blob);
    let isSafariBrowser =
      navigator.userAgent.indexOf('Safari') != -1 &&
      navigator.userAgent.indexOf('Chrome') == -1;
    if (isSafariBrowser) {
      dwldLink.setAttribute('target', '_blank');
    }
    dwldLink.setAttribute('href', url);
    dwldLink.setAttribute('download', filename + '.csv');
    dwldLink.style.visibility = 'hidden';
    document.body.appendChild(dwldLink);
    dwldLink.click();
    document.body.removeChild(dwldLink);
  }

  adminPanelBaseDataBasedOnTypeOfFileSubscription(){
    if (this.adminBaseDataBasedOnTypeOfFileSubscription) {
      this.adminBaseDataBasedOnTypeOfFileSubscription.unsubscribe();
    }
    this.adminBaseDataBasedOnTypeOfFileSubscription = this.adminBaseDataBasedOnTypeOfFileObservable.subscribe(
      (data) => {
        if(this.adminBaseDataBasedOnTypeOfFile!==data){
        this.downloadBaseData(this.selectedDownloadFile,data)
        }
        this.adminBaseDataBasedOnTypeOfFile=data
        this.adminBaseDataBasedOnTypeOfFileSubscription.unsubscribe();
      }
    );
  }

  paginationChange(pageEvt: PageEvent) {
    this.start = pageEvt.pageIndex * this.pageSize;
    this.end = this.start + this.pageSize;
    this.pageIndex = pageEvt.pageIndex;
    this.dataSource.data = this.filtered_admin_base_data.slice(
      this.start,
      this.end
    );
  }

  getUniqueColumnValues(data: any, index: number) {
    let channels: { [key: string]: number } = {};
    let casers: { [key: string]: number } = {};
    let groups: { [key: string]: number } = {};
    data.forEach((v: any) => {
      if (!channels[v.channel]) {
        channels[v.channel] = 1;
      }
      if (!casers[v.caser]) {
        casers[v.caser] = 1;
      }
      if (!groups[v.group]) {
        groups[v.group] = 1;
      }
    
    });
    if (index == 0) this.channels = ['All', ...Object.keys(channels)];
    if (index <= 1) this.casers = ['All', ...Object.keys(casers)];
    if (index <= 3) this.groups = ['All', ...Object.keys(groups)];
    this.setInitialSelection(index);
  }

  setInitialSelection(index:number) {
    let sequence=[this.channels,this.casers,this.groups]
    this.selectionSequence.forEach((dropdown,i)=>{
      if(index==0 || (i>=index && i<this.selectionSequence.length))
        this.base_data_dropdown_form_group.controls[dropdown]?.setValue(
        sequence[i]
      );
    })
  }

  toggleSelection(name:string ,formName:string,index:number){
    let sequence=[this.channels,this.casers,this.groups]
    if(name=="All" && ! this.base_data_dropdown_form_group.controls[formName]?.value.includes("All")){
      this.base_data_dropdown_form_group.controls[formName]?.setValue([]);
    }
    else if (
      name=="All" &&  this.base_data_dropdown_form_group.controls[formName].value.includes('All')
    ) {
      this.selectionSequence.forEach((v, i) => {
        if (i >= index && i < this.selectionSequence.length) {
              this.base_data_dropdown_form_group.controls[v]?.setValue(sequence[i]);
        }
      });
    }
    else {
      
      if(! this.base_data_dropdown_form_group.controls[formName].value.includes(name) &&  this.base_data_dropdown_form_group.controls[formName].value.includes("All")){
        this.base_data_dropdown_form_group.controls[formName]?.setValue(sequence[index].filter((v:any)=>v!=="All" && v!==name));
      }
      this.selectionSequence.forEach((v, i) => {
       if (i > index && i < this.selectionSequence.length) {
        this.base_data_dropdown_form_group.controls[v]?.setValue(sequence[i]);
       }
     });
   }
   this.onfilterChange(index,formName)
  }

  onfilterChange(index: number, formName: string) {
    let selectedChannel =
    this.base_data_dropdown_form_group.controls['channel'].value;
    let selectedCaser =
    this.base_data_dropdown_form_group.controls['caser'].value;
    let selectedGroup =
    this.base_data_dropdown_form_group.controls['group'].value;
    if (formName == 'channel' && selectedChannel.includes('All')) {
      this.filtered_admin_base_data= this.adminBaseData;
      this.dataSource.data =  this.filtered_admin_base_data.slice(0, this.pageSize);
      this.getUniqueColumnValues(this.filtered_admin_base_data, 0);
    } else {
      this.filtered_admin_base_data = this.adminBaseData.filter(
        (v) =>
        ((!selectedChannel.includes('All') && selectedChannel.length!==0)
            ? selectedChannel.includes(v['channel'])
            : true) && ((!selectedCaser.includes('All') && selectedCaser.length!==0)
            ? selectedCaser.includes(v['caser'])
            : true) && ((!selectedGroup.includes('All') && selectedGroup.length!==0)
            ? selectedGroup.includes(v['group'])
            : true));
      this.dataSource.data = this.filtered_admin_base_data .slice(0, this.pageSize);
      this.getUniqueColumnValues(this.filtered_admin_base_data , index + 1);
    }
    this.pageIndex = 0;
    this.start = 0;
    this.end = this.pageSize;
  }
}
